type CatalogApiLike = {
  getEntities: (request: any) => Promise<{ items?: any[] }>;
};

export async function getAllEntities(
  catalogApi: CatalogApiLike,
  request: any,
  options?: { pageSize?: number; maxResults?: number },
): Promise<any[]> {
  const pageSize = options?.pageSize ?? 200;
  const maxResults = options?.maxResults ?? 5000;

  let offset = 0;
  const items: any[] = [];

  // Catalog API defaults to a small page size; explicitly page to ensure we fetch everything.
  while (items.length < maxResults) {
    const res = await catalogApi.getEntities({
      ...request,
      limit: pageSize,
      offset,
    });

    const batch = res?.items ?? [];
    items.push(...batch);

    if (batch.length < pageSize) break;
    offset += pageSize;
  }

  return items;
}
